var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgCBurnUp = function SvgCBurnUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M84 18a6 6 0 0 1-8.587 5.415L61.415 37.413a6 6 0 0 1-8.002 8.002L23.415 75.413a6 6 0 1 1-2.828-2.829l29.998-29.997a5.964 5.964 0 0 1-.562-2.053l-6.67-1.82a6 6 0 0 1-6.472 3.182l-3.291 7.24a6 6 0 1 1-3.47-2.031l3.29-7.24a6 6 0 1 1 10.45-5.157l7.156 1.95a5.999 5.999 0 0 1 4.243-2.613l1.565-10.954a6 6 0 1 1 3.917.863l-1.413 9.89 13.257-13.257A6 6 0 1 1 84 18zm-68-4v3.2h4V14a2 2 0 1 0-4 0zm0 9.6V30h4v-6.4h-4zm0 12.8v6.4h4v-6.4h-4zm0 12.8v6.4h4v-6.4h-4zM16 62v6.4h4V62h-4zm11.6 18H34v-4h-6.4v4zm12.8 0h6.4v-4h-6.4v4zm12.8 0h6.4v-4h-6.4v4zM66 80h6.4v-4H66v4zm12.8 0H82a2 2 0 1 0 0-4h-3.2v4zM60 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM36 36a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm-9 17a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm27-13a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"
  })));
};

export default SvgCBurnUp;